import UserAvatar from '../../../ui-kit/components/atoms/UserAvatar'
import ReactionItemTemplate from '../../templates/ReactionItemTemplate'

const UserReaction = ({reaction}) => {
  return (
    <div className="user-reaction">
      <div className="avatar-container">
        <UserAvatar size="big" />
        {reaction && <ReactionItemTemplate size="micro" type={reaction} />}
      </div>
      <p>Castulo Primero</p>
    </div>
  )
}

export default UserReaction
